// useDarkMode.js - React hook for toggling dark mode
import { useEffect } from "react";

export default function useDarkMode() {
  useEffect(() => {
    const match = window.matchMedia("(prefers-color-scheme: dark)");
    const setTheme = (dark) => {
      document.documentElement.setAttribute(
        "data-theme",
        dark ? "dark" : "light"
      );
    };
    setTheme(match.matches);
    const listener = (e) => setTheme(e.matches);
    match.addEventListener("change", listener);
    return () => match.removeEventListener("change", listener);
  }, []);
}
